import { Injectable } from '@angular/core';
import { ApiService } from '../base/api.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService extends ApiService {
  countries(): Observable<any> {
    return this.get('/platform/api/countries');
  }

  location(request: any): Observable<any> {
    return this.post('/platform/api/locations', request);
  }


  employeeRanges(countryId: any): Observable<any> {
    return this.get(`/platform/api/countries/${countryId}/employeeRanges`);
  }

  salesRanges(countryId: any): Observable<any> {
    return this.get(`/platform/api/countries/${countryId}/salesRanges`);
  }

  economicActivities(countryId: any): Observable<any> {
    return this.get(`/platform/api/countries/${countryId}/economicActivities`);
  }

  ownershipType(countryId: any): Observable<any> {
    return this.get(`/platform/api/countries/${countryId}/ownershipTypes`);
  }

  taxStatus(countryId: any): Observable<any> {
    return this.get(`/platform/api/countries/${countryId}/taxStatus`);
  }

  companies(request: any): Observable<any> {
    return this.post('/platform/api/companies', request);
  }

  saveSearch(request: any): Observable<any> {
    return this.post('/platform/api/orders/create-draft', request);
  }


}
